import { render, staticRenderFns } from "./leave_receipts_dialog.vue?vue&type=template&id=6fe120b8&scoped=true"
import script from "./leave_receipts_dialog.vue?vue&type=script&lang=js"
export * from "./leave_receipts_dialog.vue?vue&type=script&lang=js"
import style0 from "./leave_receipts_dialog.vue?vue&type=style&index=0&id=6fe120b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe120b8",
  null
  
)

export default component.exports